module.exports = __webpack_public_path__ + "static/img/exit_bg.f20e1e61.png";